/** VMK 9-page offerte layout: pages 1–3 template, 4+ drawings, then pages 5–9 tail (after drawings). */
export const VMK_TEMPLATE_FRONT_PAGES = 3;
export const VMK_DRAWING_BASE_PAGE = 4;
export const VMK_TEMPLATE_TAIL_PAGE_COUNT = 5;

export const getDrawingPageNumber = (chunkIndex) => VMK_DRAWING_BASE_PAGE + chunkIndex;

/** @param {number} drawingPageCount - number of drawing/pricing pages */
export const getTailStartPage = (drawingPageCount) =>
  VMK_DRAWING_BASE_PAGE + Math.max(0, drawingPageCount);

/** @param {number} drawingPageCount @param {number} offset 0..4 → investment .. agreement */
export const getTailPageNumber = (drawingPageCount, offset) =>
  getTailStartPage(drawingPageCount) + offset;

export const formatTemplatePageLabel = (pageNumber) =>
  String(Math.max(1, pageNumber)).padStart(2, '0');
